import request from '@/utils/request'
import Setting from '../settings'
const {
  interFaceDomain
} = Setting
// 获取任务统计
export function launchList(data) {
  return request({
    url: interFaceDomain+'/front/traffic/puts',
    method: 'post',
    data
  })
}
// 获取预估详情
export function  estimateDetail(data) {
  return request({
    url: interFaceDomain+'/front/traffic/getEstimateDataList',
    method: 'post',
    data
  })
}
// 获取所有产品
export function  getProduct(params) {
  return request({
    url: interFaceDomain+'/front/product/getProductListSelect',
    method: 'get',
    params
  })
}

